export default function isProductAtcValid(atc: string): boolean {
	return atc.match(/^Q?[A-Z](\d\d([A-Z]([A-Z](\d\d)?)?)?)?$/) !== null;
}
